webpackJsonp([11],{

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(53)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(59),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 53:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      users: [],
      searchText: ''
    };
  },

  computed: {
    filteredUsers: function filteredUsers() {
      var _this = this;

      return this.users.filter(function (user) {
        return user.name.toLowerCase().match(_this.searchText.toLowerCase());
      });
    }
  },
  methods: {
    pushProfile: function pushProfile(id) {
      this.$router.push('/profile/' + id);
    }
  },
  created: function created() {
    var _this2 = this;

    __WEBPACK_IMPORTED_MODULE_0__Firebase_FirebaseInit__["a" /* default */].firestore().collection('users').get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        var user = {
          'id': doc.id,
          'name': doc.data().name,
          'email': doc.data().email,
          'bio': doc.data().bio,
          'photoURL': doc.data().photoURL,
          'contacts': doc.data().contacts
        };
        if (user.name != null && user.id !== _this2.$store.getters.user.id) {
          _this2.users.push(user);
        }
      });
    });
  }
});

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-toolbar-title', [_vm._v("Search: ")]), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.filteredUsers,
      "box": "",
      "chips": "",
      "color": "secondary",
      "item-text": "name",
      "item-value": "name",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return undefined
      }
    }, {
      key: "item",
      fn: function(data) {
        return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-tile-avatar', [_c('img', {
          attrs: {
            "src": data.item.photoURL
          }
        })]), _vm._v(" "), _c('v-list-tile-content', {
          on: {
            "click": function($event) {
              _vm.pushProfile(data.item.id)
            }
          }
        }, [_c('v-list-tile-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.name)
          }
        }), _vm._v(" "), _c('v-list-tile-sub-title', {
          domProps: {
            "innerHTML": _vm._s(data.item.group)
          }
        })], 1)]]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.f5645b517bf05ab7817b.js